// extracted by mini-css-extract-plugin
export var active = "_ig-7";
export var blink = "_ig-8";
export var dropDownSelector = "_ig-4";
export var dropDownWrapper = "_ig-3";
export var fakeCursor = "_ig-6";
export var fontSizeButton = "_ig-9";
export var formQuillEditor = "_ig-0";
export var pressed = "_ig-a";
export var qlBlank = "_ig-1";
export var textFormattingToolbar = "_ig-2";
export var textToolbarOption = "_ig-5";